import { render, staticRenderFns } from "./NavComponent.vue?vue&type=template&id=f51dd58c&scoped=true&"
import script from "./NavComponent.vue?vue&type=script&lang=js&"
export * from "./NavComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavComponent.vue?vue&type=style&index=0&id=f51dd58c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51dd58c",
  null
  
)

export default component.exports